import React, { useState, useEffect, useCallback } from "react";
import { AleartModalButton, PrimaryButton } from "../../components/UIkit";
import { useDispatch, useSelector } from "react-redux";
import { getUserId } from "../../reducks/users/selectors";
import { db } from "../../firebase/index";
import { storage } from "../../firebase/index";
import { OrganizerHeader } from "../../components/header";
import { saveAvatar } from "../../reducks/users/operations";
import "../../assets/css/avatarEdit.css";
import { hideLoadingAction, showLoadingAction } from "../../reducks/loading/actions";
import { push } from "connected-react-router";
import GuestImage from "../../assets/img/src/no-profile.png";

const AvatarEdit = () => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const uid = getUserId(selector);

  const [avatar, setAvatar] = useState("");

  const fechAvatar = () => {
    db.collection("users")
      .doc(uid)
      .get()
      .then((snapshot) => {
        const data = snapshot.data();
        setAvatar(data.avatar);
      });
  };

  const uploadImage = useCallback(
    (event) => {
      dispatch(showLoadingAction("uploading..."));
      const file = event.target.files;
      let blob = new Blob(file, { type: "image/jpeg" });

      // Generate random 16 digits strings
      // const S = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      // const N = 16;
      // const fileName = Array.from(crypto.getRandomValues(new Uint32Array(N)))
      //   .map((n) => S[n % S.length])
      //   .join("");

      const uploadRef = storage.ref("users").child(uid).child(uid);
      const uploadTask = uploadRef.put(blob);

      uploadTask
        .then(() => {
          // Handle successful uploads on complete
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            const newImage = { id: uid, path: downloadURL };
            setAvatar(newImage.path);
            dispatch(hideLoadingAction());
          });
        })
        .catch(() => {
          console.log("エラー");
          dispatch(hideLoadingAction());
        });
    }, // eslint-disable-next-line
    [setAvatar]
  );

  useEffect(() => {
    fechAvatar();
    // eslint-disable-next-line
  }, []);

  return (
    <section>
      <div className="common-container">
        <div className="common-container__header--inner center-box">
          <OrganizerHeader />
          <div className="mypage-container">
            <h2 className="form-text__headline--l center">アバターの登録</h2>
            <div className="spacer-box--s" />
            <div className="center preview-box">
              <label htmlFor="avatar">
                {typeof avatar !== "undefined" ? (
                  <img className="avatar-basic hover1 " src={avatar} alt="プレビュー画像" />
                ) : (
                  <img className="avatar-trim hover1" src={GuestImage} alt="アバター画像" width="50" />
                )}
                <input
                  className="display-none"
                  type="file"
                  name="avatar"
                  id="avatar"
                  onChange={(event) => uploadImage(event)}
                />
              </label>
            </div>
            <div className="spacer-box--s" />
            <div className="basic-text--s center">Tap or Click</div>
            <div className="spacer-box--l" />
            <div className="center">
              <PrimaryButton label={"アバターを登録"} onClick={() => dispatch(saveAvatar(uid, avatar))} />
              <div className="spacer-box--m" />
              <AleartModalButton
                title="保存されいない内容は消去されます"
                text="よろしいですか？"
                onClick={() => dispatch(push(`/organizer/${uid}`))}
                label="TOPへ戻る"
                className="top-back-btn"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AvatarEdit;
